var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.changeHandler}}),_c('span',{staticClass:"slider round",class:_vm.className})])
}
var staticRenderFns = []

export { render, staticRenderFns }